(() => {
  const initializePackPicker = (picker) => {
    if (picker.dataset.eurosolPackInitialized === 'true') return;

    const productInfo = picker.closest('product-info');
    const options = Array.from(picker.querySelectorAll('[data-eurosol-pack-option]'));
    const media = productInfo?.querySelector('[data-eurosol-pack-media]');
    const mediaImage = media?.querySelector('[data-eurosol-pack-image]');
    const thumbnails = Array.from(productInfo?.querySelectorAll('[data-eurosol-pack-thumbnail]') || []);
    const priceDisplays = Array.from(productInfo?.querySelectorAll('[data-eurosol-pack-price-display]') || []);
    const stickySelection = productInfo?.querySelector('.eurosol-sticky-selection');
    const productTitle = media?.dataset.productTitle || '';

    if (!productInfo || !options.length) return;
    picker.dataset.eurosolPackInitialized = 'true';

    [1, 2, 3].forEach((packSize) => {
      const source = media?.getAttribute(`data-image-${packSize}`);
      if (!source) return;
      const preload = new Image();
      preload.src = source;
    });

    const updateMedia = (packSize, label) => {
      const source = media?.getAttribute(`data-image-${packSize}`);
      if (source && mediaImage && mediaImage.getAttribute('src') !== source) {
        media.classList.add('is-changing');
        mediaImage.src = source;
        mediaImage.alt = `${productTitle} als ${label}`;
        const reveal = () => media.classList.remove('is-changing');
        if (mediaImage.complete) reveal();
        else mediaImage.addEventListener('load', reveal, { once: true });
      }

      thumbnails.forEach((thumbnail) => {
        const isActive = thumbnail.dataset.eurosolPackThumbnail === String(packSize);
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const updatePrice = (option) => {
      priceDisplays.forEach((display) => {
        const currentPrice = display.querySelector('[data-eurosol-pack-current-price]');
        const unitPrice = display.querySelector('[data-eurosol-pack-unit-price]');
        const savings = display.querySelector('[data-eurosol-pack-savings]');
        if (currentPrice) currentPrice.textContent = option.dataset.price || '';
        if (unitPrice) unitPrice.textContent = option.dataset.unitPrice || '';
        if (savings) {
          savings.textContent = option.dataset.savings || '';
          savings.hidden = !option.dataset.savings;
        }
      });
    };

    const applyOption = (option) => {
      if (!option || option.disabled) return;

      const variantId = option.dataset.variantId;
      const packSize = option.dataset.eurosolPackOption;
      const label = option.dataset.label || '';

      options.forEach((candidate) => {
        const isActive = candidate === option;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      productInfo.querySelectorAll('form input[name="id"]').forEach((input) => {
        input.disabled = false;
        input.value = variantId;
        input.setAttribute('value', variantId);
      });

      productInfo.querySelectorAll('form input[name="quantity"]').forEach((input) => {
        input.value = '1';
        input.setAttribute('value', '1');
      });

      productInfo.querySelectorAll('product-form button[type="submit"]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });

      if (stickySelection) stickySelection.textContent = `${productTitle} · ${label}`;
      updatePrice(option);
      updateMedia(packSize, label);
    };

    options.forEach((option) => option.addEventListener('click', () => applyOption(option)));
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const option = options.find(
          (candidate) => candidate.dataset.eurosolPackOption === thumbnail.dataset.eurosolPackThumbnail
        );
        applyOption(option);
      });
    });

    const initialOption = options.find(
      (option) => option.dataset.eurosolPackOption === '3' && !option.disabled
    ) || options.find((option) => !option.disabled);
    applyOption(initialOption);
    window.addEventListener('load', () => window.setTimeout(() => applyOption(initialOption), 150), { once: true });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-eurosol-pack-picker]').forEach(initializePackPicker);
  };

  initializeAll();
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
